import { View } from "@react-pdf/renderer"
import { ReactNode } from "react"

export const PageWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <View
      style={{
        padding: "30px 50px 30px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {children}
    </View>
  )
}
